import { graphql } from "gatsby"

export const linkResolver = (doc, parent) => {
  switch (doc.type) {
    case "home_page":
      return "/"
    case "blog_page":
      return "/blog"
    case "blog_post":
      return `/blog/${doc.uid}`
    case "portfolio":
      return "/portfolio"
    case "success_story":
      return `/portfolio/${doc.uid}`
    case "landing_page":
      return `/landing/${doc.uid}`
    case "content_page":
      if (parent) {
        if(parent.parent) {
          return `/${parent.parent._meta.uid}/${parent._meta.uid}/${doc.uid}`
        }
        return `/${parent._meta.uid}/${doc.uid}`
      }
      return `/${doc.uid}`
  }
}

export const linkFragment = graphql`  
    fragment link on PRISMIC__Linkable {
        _linkType
        ... on PRISMIC_Content_page {
            _linkType
            _meta {
                uid
                type
                lang
            }
            parent {
                ... on PRISMIC_Content_page {
                    _meta {
                        uid
                        type
                        lang
                    }
                    parent {
                        ... on PRISMIC_Content_page {
                            _meta {
                                uid
                                type
                                lang
                            }
                        }
                    }
                }
            }
        }
        ... on PRISMIC_Home_page {
            _linkType
            _meta {
                uid
                type
                lang
            }
        }
        ... on PRISMIC_Success_story {
            _linkType
            _meta {
                uid
                lang
                type
            }
        }
        ... on PRISMIC_Blog_post {
            _linkType
            _meta {
                uid
                lang
                type
            }
        }
        ... on PRISMIC_Blog_page {
            _linkType
            _meta {
                uid
                lang
                type
            }
        }
        ... on PRISMIC_Portfolio {
            _linkType
            _meta {
                uid
                lang
                type
            }
        }
        ... on PRISMIC__ExternalLink {
            _linkType
            url
        }
    }
`
